import { ref } from 'vue'

const THEME_STORAGE_KEY = 'theme'
const isDark = ref(false)

const canUseDom = () => typeof window !== 'undefined' && typeof document !== 'undefined'

const applyTheme = () => {
  if (!canUseDom()) return

  const root = document.documentElement
  const body = document.body

  root.classList.toggle('dark', isDark.value)
  body.classList.toggle('dark', isDark.value)
  body.classList.toggle('light', !isDark.value)
}

const setTheme = (theme) => {
  isDark.value = theme === 'dark'

  if (typeof window !== 'undefined') {
    localStorage.setItem(THEME_STORAGE_KEY, isDark.value ? 'dark' : 'light')
  }

  applyTheme()
}

const toggleTheme = () => {
  setTheme(isDark.value ? 'light' : 'dark')
}

const initTheme = () => {
  if (typeof window !== 'undefined') {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY)
    isDark.value = storedTheme === 'dark'
  }

  applyTheme()
}

export function useTheme() {
  return {
    isDark,
    toggleTheme,
    setTheme,
    applyTheme,
    initTheme,
  }
}

